import React from "react";

import { chartColors } from "../../../config/colors";

interface InfoProps {
  link: string;
  transform?: string;
}

export const InfoSymbol: React.FC<InfoProps> = ({ link, transform = "" }) => {
  return (
    <g className="info" transform={transform}>
      <a
        href={link}
        target="_blank"
        rel="noopener"
        role="link"
        style={{ cursor: "pointer", WebkitTapHighlightColor: "transparent" }}
      >
        <circle
          cx="10"
          cy="10"
          r="10"
          fill={chartColors.white}
          stroke={chartColors.fontSecondary}
          strokeWidth="2"
        >
          <title>Erklärung öffnen</title>
        </circle>
        <text
          x="10"
          y="10"
          dy="6"
          fontFamily="TheMixExtraBold, sans-serif"
          fontWeight="700"
          fontSize="16"
          textAnchor="middle"
          fill={chartColors.fontSecondary}
        >
          i
        </text>
      </a>
    </g>
  );
};
